import * as React from "react";

import { cn } from "@/lib/utils";

export interface SwitchProps
  extends Omit<React.ComponentProps<"input">, "size"> {
  size?: "sm" | "md" | "lg";
  id?: string;
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ className, size = "sm", id, ...props }, ref) => {
    const getSizeClasses = () => {
      switch (size) {
        case "md":
          return "wl-switch-md";
        case "lg":
          return "wl-switch-lg";
        default:
          return "wl-switch-sm";
      }
    };

    const switchId = id || `switch-${Math.random().toString(36).substr(2, 9)}`;

    return (
      <label
        htmlFor={switchId}
        className={cn("wl-switch-container", getSizeClasses(), className)}
      >
        <input
          ref={ref}
          id={switchId}
          type="checkbox"
          role="switch"
          className="wl-input-checkbox"
          {...props}
        />
        <div className="wl-switch-slider" />
      </label>
    );
  }
);

Switch.displayName = "Switch";

export { Switch };
